








































































import { Component, Watch, Vue } from "vue-property-decorator";
import moment from "moment";



@Component({
  components: {

  },
  computed: {

  },
})
export default class CheckinListView extends Vue {

  htmlBody = "";
  table: any = null;
  tableXml: any = null;
  tableJson: any = null;
  tableLastUpdate = null;
  body = this.createElementFromHTML("<div class='table-container'><table class='table checking-list-table table-borderless'><thead></thead><tbody></tbody></table></div>");
  lastIndex = 0;
  pageTimer: any = null;
  checkPlaylist =  this.$route.params.p? false:true;

  @Watch("tableLastUpdate", { deep: true })
  onFilterChanged() {
    this.htmlBody = this.body.outerHTML;
  }


  async loadTable(rowsOnly) {

      

    if (!rowsOnly) {
      this.$store.commit("main/SET_LOADING", true);
    }

    try {
      var table = this.$route.params.t;
      this.table = await this.$store.dispatch("schedule/getWaitingListTable", table);

      const parser: DOMParser = new DOMParser();
      this.tableXml = parser.parseFromString(this.table.tableXml, "application/xml").getElementsByTagName("Table")[0];

      // TEMPORARY HANDLING OF MORE THAN 1 TABLE
      if (this.checkPlaylist && !this.inIframe() && this.tableXml.getAttribute("PlaylistID")) {
            window.location.href = this.$router.resolve({name: 'checkin-lists', params: {p: this.tableXml.getAttribute("PlaylistID")}}).href
            return;
          }
          //

      if (rowsOnly) {
        if (moment(this.table.lastUpdate).isAfter(this.tableLastUpdate)) {
          clearTimeout(this.pageTimer);
          this.lastIndex = 0;
          this.showRows();
        }

      } else {
        this.showTable();
      }




      if (parseInt(this.tableXml.getAttribute("UpdateInterval"))) {
        const updateInterval = parseInt(this.tableXml.getAttribute("UpdateInterval"));
        setTimeout(() => {
          this.loadTable(true);
        }, updateInterval);
      }

      this.tableLastUpdate = this.table.lastUpdate;


    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }


  async getFile(id) {
    try {
      var data = await this.$store.dispatch("schedule/getContentFile", id);
      return data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }

   getURL(id) {

    return process.env.VUE_APP_ROOT_API+"/schedule/wmpc/content/file/"+ id;
   
  }

  inIframe () {
      try {
          return (window.self !== window.top);
      } catch (e) {
          return true;
      }
    }



  showTable() {
    this.lastIndex = 0;
    this.setBody();
    this.setProps(this.tableXml, this.body);
    this.showTitles();
    this.showHeaders();
    this.showRows();

    this.htmlBody = this.body.outerHTML;
  }

  setBody() {
    const backImage = this.tableXml.querySelector("BackImage");
    if (backImage) {
      let src: string | null = null;

      if (backImage.getAttribute("ContentID")) {
        src = this.getURL(backImage.getAttribute("ContentID"));
      } else if (backImage.getAttribute("Source")) {
        src = this.getURL(backImage.getAttribute("Source"));
      }
      if (backImage.getAttribute("WMContentID")) {
        src = this.getURL(backImage.getAttribute("WMContentID"));
      } else if (backImage.getAttribute("WMSource")) {
        src = this.getURL(backImage.getAttribute("WMSource"));
      }
      const imgBg = document.querySelector(".img-bg") as HTMLImageElement;
      if (imgBg) {
        imgBg.src = src!;
      } else {
        const img = document.createElement("img");
        img.className = "img-bg";
        img.src = src!;
        this.body.appendChild(img);
      }
    } else {
      const imgBgElements = this.body.querySelectorAll(".img-bg");
      imgBgElements.forEach(element => element.remove());
    }
    const wmViewWidth = this.tableXml.getAttribute("WMViewWidth");
    if (wmViewWidth) {
      let width = wmViewWidth;
      if (width === "full") {
        width = screen.availWidth + "px";
      } else if (width === "half") {
        width = (screen.availWidth / 2) + "px";
      }
      const tableContainers = this.body.querySelectorAll(".table-container");
      tableContainers.forEach(container => {
        (container as HTMLElement).style.width = width;
      });
    }
    this.setProps(this.tableXml, this.body);
  }

  showTitles() {
    const titles = this.body.querySelectorAll(".title");
    titles.forEach(title => title.remove());
    const headerFooterTitles = this.tableXml.querySelectorAll("HeaderTitle, FooterTitle");
    headerFooterTitles.forEach((title: Element) => {
      const div = document.createElement("div");
      div.className = "title";
      const image = title.querySelector("Image");
      if (image) {
        const img = this.colImage(image);
        div.appendChild(img);
      } else {
        div.textContent = title.textContent;
      }
      this.setProps(title, div);
      var table = this.body.querySelector(".table");
      if (title.tagName === "HeaderTitle") {
        table!.parentNode!.insertBefore(div, table);
      } else {
        div.classList.add("fixed-bottom");
        table!.parentNode!.insertBefore(div, this.table.nextSibling);
      }
    });
  }

  showHeaders() {
    const table: HTMLElement | null = this.body.querySelector(".table");
    const thead = table!.querySelector("thead") as HTMLTableSectionElement;
    thead.innerHTML = "";
    const headerRows = this.tableXml.querySelectorAll("Headers Row");
    headerRows.forEach((row: Element) => {
      const tr = this.tableRow(row);
      this.setProps(row.parentElement!, tr);
      thead.appendChild(tr);
    });
  }


  showRows() {
    const tbody = this.body.querySelector("tbody") as HTMLTableSectionElement;
    const rows = this.tableXml.querySelectorAll("Rows Row");
    let pageSize = 0;
    let pageInterval = 0;
    if (this.tableXml.getAttribute("PageSize")) {
      pageSize = parseInt(this.tableXml.getAttribute("PageSize"), 10);
    }
    if (this.tableXml.getAttribute("WMPageSize")) {
      pageSize = parseInt(this.tableXml.getAttribute("WMPageSize"), 10);
    }
    if (this.tableXml.getAttribute("PageInterval")) {
      pageInterval = parseInt(this.tableXml.getAttribute("PageInterval"), 10);
    }
    if (this.tableXml.getAttribute("WMPageInterval")) {
      pageInterval = parseInt(this.tableXml.getAttribute("WMPageInterval"), 10);
    }

    let count = 1;
    tbody.innerHTML = "";
    for (; this.lastIndex < rows.length; this.lastIndex++) {
      const row = rows[this.lastIndex] as Element;
      const tr = this.tableRow(row);
      this.setProps(row.parentElement!, tr);
      tbody.appendChild(tr);
      if ((pageSize > 0) && (count === pageSize)) {
        this.lastIndex += 1;
        break;
      }
      count++;
    }
    if (this.lastIndex === rows.length) {
      this.lastIndex = 0;
    }
    if ((pageSize > 0) && (pageInterval > 1000)) {
      this.pageTimer = setTimeout(this.showRows, pageInterval);
    }
  }

  showRowsBK() {
    const tbody = this.body.querySelector("tbody") as HTMLTableSectionElement;
    const rows = this.tableJson.Rows.Row;
    let pageSize = 0;
    let pageInterval = 0;
    if (this.tableXml.PageSize) {
      pageSize = parseInt(this.tableJson.PageSize, 10);
    }
    if (this.tableJson.WMPageSize) {
      pageSize = parseInt(this.tableJson.WMPageSize, 10);
    }
    if (this.tableJson.PageInterval) {
      pageInterval = parseInt(this.tableJson.PageInterval, 10);
    }
    if (this.tableJson.WMPageInterval) {
      pageInterval = parseInt(this.tableJson.WMPageInterval, 10);
    }
    let count = 1;
    tbody.innerHTML = "";
    for (; this.lastIndex < rows.length; this.lastIndex++) {
      const row = rows[this.lastIndex] as Element;
      const tr = this.tableRow(row);
      this.setProps(row.parentElement!, tr);
      tbody.appendChild(tr);
      if ((pageSize > 0) && (count === pageSize)) {
        this.lastIndex += 1;
        break;
      }
      count++;
    }
    if (this.lastIndex === rows.length) {
      this.lastIndex = 0;
    }
    if ((pageSize > 0) && (pageInterval > 1000)) {
      this.pageTimer = setTimeout(this.showRows, pageInterval);
    }
  }

  tableRow(row: Element): HTMLTableRowElement {
    const tr = document.createElement("tr");
    if (row.parentElement!.tagName === "Headers") {
      tr.style.fontWeight = "bold";
    }
    this.setProps(row, tr);
    row.querySelectorAll("Col").forEach((col: Element) => {
      const td = this.tableCol(col);
      tr.appendChild(td);
    });
    return tr;
  }

  tableCol(col: Element): HTMLTableCellElement {
    const td = document.createElement("td");
    const div = document.createElement("div");
    td.appendChild(div);
    col.childNodes.forEach((child: ChildNode) => {
      if (child.nodeType === Node.ELEMENT_NODE) {
        const element = child as Element;
        switch (element.tagName) {
          case "Image":
            var img = this.colImage(element);
            div.appendChild(img);
            break;
          case "FaIcon":
            var faIcon = document.createElement("i");
            faIcon.className = `fa fa-${element.textContent}`;
            div.appendChild(faIcon);
            break;
          case "Space":
            var spaces = parseInt(element.textContent!, 10);
            for (let i = 0; i < spaces; i++) {
              div.appendChild(document.createTextNode("\u00A0"));
            }
            break;
        }
      } else if (child.nodeType === Node.TEXT_NODE) {
        div.appendChild(document.createTextNode(child.nodeValue!));
      }
    });
    this.setProps(col, td);
    this.setProps(col, div);
    return td;
  }

  colImage(xml: Element): HTMLImageElement {
    const img = document.createElement("img");
    if (xml.getAttribute("Width")) {
      img.style.width = xml.getAttribute("Width")!;
    }
    if (xml.getAttribute("Height")) {
      img.style.height = xml.getAttribute("Height")!;
    }
    if (xml.getAttribute("WMWidth")) {
      img.style.width = xml.getAttribute("WMWidth")!;
    }
    if (xml.getAttribute("WMHeight")) {
      img.style.height = xml.getAttribute("WMHeight")!;
    }
    let src: string | null = null;
    if (xml.getAttribute("ContentID")) {
      src = this.getURL(xml.getAttribute("ContentID"));
    } else if (xml.getAttribute("Source")) {
      src = xml.getAttribute("Source");
    }
    if (xml.getAttribute("WMContentID")) {
      src = this.getURL(xml.getAttribute("WMContentID"));
    } else if (xml.getAttribute("WMSource")) {
      src = xml.getAttribute("WMSource");
    }
    if (src) {
      img.src = src!;
    } else {
      img.style.display = "none";
    }

    return img;
  }

  setProps(xml: Element, elem: HTMLElement) {
    const xmlProps: { [key: string]: string } = {
      "BackColor": "background-color",
      "BackgroundColor": "background-color",
      "FontColor": "color",
      "FontName": "font-family",
      "FontSize": "font-size",
      "TextAlign": "text-align",
      "BorderColor": "border",
      "Width": "width",
      "Height": "height",
      "RowSpan": "rowspan",
      "ColSpan": "colspan",
      "Margin": "margin",
      "MarginTop": "margin-top",
      "MarginRight": "margin-right",
      "MarginBottom": "margin-bottom",
      "MarginLeft": "margin-left",
      "Padding": "padding",
      "PaddingTop": "padding-top",
      "PaddingRight": "padding-right",
      "PaddingBottom": "padding-bottom",
      "PaddingLeft": "padding-left",
    };
    Object.keys(xmlProps).forEach(xmlName => {
      const propName = xmlProps[xmlName];
      const wmXmlName = `WM${xmlName}`;
      let propVal: string | null = null;
      if (xml.getAttribute(xmlName)) {
        propVal = xml.getAttribute(xmlName);
      } else if (xml.parentElement && xml.parentElement.getAttribute(xmlName)) {
        propVal = xml.parentElement.getAttribute(xmlName);
      }
      if (xml.getAttribute(wmXmlName)) {
        propVal = xml.getAttribute(wmXmlName);
      } else if (xml.parentElement && xml.parentElement.getAttribute(wmXmlName)) {
        propVal = xml.parentElement.getAttribute(wmXmlName);
      }
      if (propVal) {
        if (xmlName === "RowSpan" || xmlName === "ColSpan") {
          elem.setAttribute(propName, propVal);
        } else if (wmXmlName === "WMRowSpan" || wmXmlName === "WMColSpan") {
          elem.setAttribute(propName, propVal);
        } else {
          elem.style[propName] = propVal;
        }
      }
    });
  }


  createElementFromHTML(htmlString) {
    var template = document.createElement('div');
    template.innerHTML = htmlString.trim();
    return template;
  }

  xmlToJson(xml) {
    var obj = {};
    if (xml.nodeType === 1) {
      if (xml.attributes.length > 0) {
        obj["@attributes"] = {};
        for (let j = 0; j < xml.attributes.length; j++) {
          const attribute = xml.attributes.item(j);
          obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
        }
      }
    } else if (xml.nodeType === 3) {
      obj = xml.nodeValue;
    }

    // Process child nodes
    if (xml.hasChildNodes()) {
      for (let i = 0; i < xml.childNodes.length; i++) {
        const item = xml.childNodes.item(i);
        const nodeName = item.nodeName;
        if (typeof (obj[nodeName]) === "undefined") {
          obj[nodeName] = this.xmlToJson(item);
        } else {
          if (typeof (obj[nodeName].push) === "undefined") {
            const old = obj[nodeName];
            obj[nodeName] = [];
            obj[nodeName].push(old);
          }
          obj[nodeName].push(this.xmlToJson(item));
        }
      }
    }
    return obj;
  }

  mounted() {
    this.loadTable(false);
  }
}
